"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/attendee/types");
var _types2 = require("../../actions/meeting/types");
var isVideoActive = function isVideoActive(action) {
  return action.type === _types.BROADCAST_SET_DESIRED_ATTENDEE_CAMERA_STATUS && action.payload.isCameraOn || action.type === "".concat(_types.BROADCAST_TOGGLE_VIDEO_ACTIVE, "_SUCCESS") && action.payload.isVideoActive;
};

// Reducer for handling the video device lost state
var _default = exports["default"] = function _default() {
  var _action$payload, _action$payload2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types2.VIDEO_DEVICE_LOST) {
    return action.payload;
  }

  // Check if the video is active and if it is being called for the current attendee. Then we will mark the device lost as false.
  if (isVideoActive(action) && ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.attendeeId) === ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.currentAgoraAttendeeId)) {
    return false;
  }
  return state;
};